
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_931jFdtLGbx3g82UfuzThIwTGgnG67mCLe4_O69TB_45g_kMeta } from "/agent/_work/2/s/front/pages/[...slug].vue?macro=true";
import { default as forbidden4_ZoqJiCKoCykCxAifRQdn746hmDTSfiA7AqHQifFc4Meta } from "/agent/_work/2/s/front/pages/forbidden.vue?macro=true";
import { default as indexNGDB7EnSq6A2zCPGjwmIFauWqBN0Y0uwvKoPcQJvhrEMeta } from "/agent/_work/2/s/front/pages/users/index.vue?macro=true";
import { default as indexEC4Ukxjt_89H6C7PCV5V7bKtmsfyJLq9rO016gPlFjQMeta } from "/agent/_work/2/s/front/pages/contacts/index.vue?macro=true";
import { default as indexdutrFY0YN4X4igWPL4rgr1vbl6NnbZ5J5ApXJG1kN9MMeta } from "/agent/_work/2/s/front/pages/auth/login/index.vue?macro=true";
import { default as indexBv1EJb00_hqOwSNxYhasp21HEHuhQKMQN051R9l4rlUMeta } from "/agent/_work/2/s/front/pages/preferences/index.vue?macro=true";
import { default as indexTGlLJNvoTuuj9mcIBwaU95131_MTQSZ1SkL9QSV4I_45kMeta } from "/agent/_work/2/s/front/pages/admin/events/index.vue?macro=true";
import { default as indexxCGwc8VaiqOHZWUmUPEV_AS0JdTBF9H93HVHDegqCCwMeta } from "/agent/_work/2/s/front/pages/event/[token]/index.vue?macro=true";
import { default as index9DkGRtwnoww8tR36OEx0JoIDFZNeNYz7ZqIlkS0WIAMMeta } from "/agent/_work/2/s/front/pages/notifications/index.vue?macro=true";
import { default as indexrWIvip1NwnsHsRO9bFdTChmp5jzSn6Bhsc8LrtM5IDcMeta } from "/agent/_work/2/s/front/pages/consent/[token]/index.vue?macro=true";
import { default as indexDmdFvyr6Z_45RtI7hwsyWP_5tc4tijBqvA6jrjK_V1YY8Meta } from "/agent/_work/2/s/front/pages/mandatary/events/index.vue?macro=true";
import { default as indextz0zdenZEHorO0BtWrbeG9xRVYb5GWaoxYt2dsJq_cMMeta } from "/agent/_work/2/s/front/pages/auth/reset-password/index.vue?macro=true";
import { default as indexGFi0YW1jAIWczl7M5u4jKLu7rg9x_45ksP6RF2y2DggP4Meta } from "/agent/_work/2/s/front/pages/auth/forgot-password/index.vue?macro=true";
import { default as indexcCgGplzSHJOKARJbikJ1pvpFI8m_45zVRFwRi4nl_45xVXMMeta } from "/agent/_work/2/s/front/pages/lead-provider/requests/index.vue?macro=true";
import { default as indexSOX_e4to_45HbJLFyGd2PWdbYWH2i_hCfvF90sY_m9fb4Meta } from "/agent/_work/2/s/front/pages/lead-provider/commissions/index.vue?macro=true";
import { default as component_45stubpUXrBTxH18lLSSkjjGpYjISrm2UiNX7B_45rBwYRar9ogMeta } from "/agent/_work/2/s/front/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_22da3ade47870323d82c471ea39c0799/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubpUXrBTxH18lLSSkjjGpYjISrm2UiNX7B_45rBwYRar9og } from "/agent/_work/2/s/front/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_22da3ade47870323d82c471ea39c0799/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/agent/_work/2/s/front/pages/[...slug].vue")
  },
  {
    name: "forbidden",
    path: "/forbidden",
    component: () => import("/agent/_work/2/s/front/pages/forbidden.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexNGDB7EnSq6A2zCPGjwmIFauWqBN0Y0uwvKoPcQJvhrEMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/users/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    meta: indexEC4Ukxjt_89H6C7PCV5V7bKtmsfyJLq9rO016gPlFjQMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/contacts/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexdutrFY0YN4X4igWPL4rgr1vbl6NnbZ5J5ApXJG1kN9MMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/auth/login/index.vue")
  },
  {
    name: "preferences",
    path: "/preferences",
    meta: indexBv1EJb00_hqOwSNxYhasp21HEHuhQKMQN051R9l4rlUMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/preferences/index.vue")
  },
  {
    name: "admin-events",
    path: "/admin/events",
    meta: indexTGlLJNvoTuuj9mcIBwaU95131_MTQSZ1SkL9QSV4I_45kMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/admin/events/index.vue")
  },
  {
    name: "event-token",
    path: "/event/:token()",
    meta: indexxCGwc8VaiqOHZWUmUPEV_AS0JdTBF9H93HVHDegqCCwMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/event/[token]/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: index9DkGRtwnoww8tR36OEx0JoIDFZNeNYz7ZqIlkS0WIAMMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/notifications/index.vue")
  },
  {
    name: "consent-token",
    path: "/consent/:token()",
    meta: indexrWIvip1NwnsHsRO9bFdTChmp5jzSn6Bhsc8LrtM5IDcMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/consent/[token]/index.vue")
  },
  {
    name: "mandatary-events",
    path: "/mandatary/events",
    meta: indexDmdFvyr6Z_45RtI7hwsyWP_5tc4tijBqvA6jrjK_V1YY8Meta || {},
    component: () => import("/agent/_work/2/s/front/pages/mandatary/events/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: indextz0zdenZEHorO0BtWrbeG9xRVYb5GWaoxYt2dsJq_cMMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/auth/reset-password/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: indexGFi0YW1jAIWczl7M5u4jKLu7rg9x_45ksP6RF2y2DggP4Meta || {},
    component: () => import("/agent/_work/2/s/front/pages/auth/forgot-password/index.vue")
  },
  {
    name: "lead-provider-requests",
    path: "/lead-provider/requests",
    meta: indexcCgGplzSHJOKARJbikJ1pvpFI8m_45zVRFwRi4nl_45xVXMMeta || {},
    component: () => import("/agent/_work/2/s/front/pages/lead-provider/requests/index.vue")
  },
  {
    name: "lead-provider-commissions",
    path: "/lead-provider/commissions",
    meta: indexSOX_e4to_45HbJLFyGd2PWdbYWH2i_hCfvF90sY_m9fb4Meta || {},
    component: () => import("/agent/_work/2/s/front/pages/lead-provider/commissions/index.vue")
  },
  {
    name: component_45stubpUXrBTxH18lLSSkjjGpYjISrm2UiNX7B_45rBwYRar9ogMeta?.name,
    path: "/",
    component: component_45stubpUXrBTxH18lLSSkjjGpYjISrm2UiNX7B_45rBwYRar9og
  }
]